import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchInfoOrder } from "../../../redux/slices/order";
import { createReview, updateReview } from "../../../redux/slices/review";
import "./CompletedServices.scss";
import { memo } from "react";
import { months } from "../../../data";

const CompletedServices = memo(() => {
  const dispatch = useDispatch();
  const { order } = useSelector(state => state.order);
  const { status: reviewStatus } = useSelector(state => state.reviews);

  const [activeReview, setActiveReview] = useState(null);
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (reviewStatus === "succeeded") {
      dispatch(fetchInfoOrder());
    }
  }, [reviewStatus, dispatch]);

  const Star = ({ filled, onClick }) => {
    const starStyle = {
      cursor: "pointer",
      color: filled ? "gold" : "lightgray",
    };

    return (
      <span style={starStyle} onClick={onClick}>
        ★
      </span>
    );
  };

  const StarRating = ({ orderId, initialRating = 0 }) => {
    const [stars, setStars] = useState(
      Array(5)
        .fill(false)
        .map((_, i) => i < initialRating)
    );

    useEffect(() => {
      setStars(
        Array(5)
          .fill(false)
          .map((_, i) => i < initialRating)
      );
    }, [initialRating]);

    const handleStarClick = index => {
      const newStars = Array(5)
        .fill(false)
        .map((_, i) => i <= index);
      setStars(newStars);
      setActiveReview({ orderId, rating: index + 1 });
    };

    return (
      <>
        {stars.map((filled, index) => (
          <Star
            key={index}
            filled={filled}
            onClick={() => handleStarClick(index)}
          />
        ))}
      </>
    );
  };

  const handleSubmitReview = async () => {
    if (!activeReview) return;

    const reviewData = {
      orderId: activeReview.orderId,
      rating: Number(activeReview.rating),
      comment: String(comment || ""),
    };

    try {
      const currentOrder = order.items.find(
        item => item._id === activeReview.orderId
      );

      if (currentOrder?.review) {
        await dispatch(updateReview(reviewData)).unwrap();
      } else {
        await dispatch(createReview(reviewData)).unwrap();
      }

      await dispatch(fetchInfoOrder());
      setActiveReview(null);
      setComment("");
    } catch (error) {
      console.error("Failed to submit review:", error);
    }
  };

  // Показываем загрузку
  if (order.status === "loading") {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
        Загрузка заказов...
      </div>
    );
  }

  // Показываем ошибку
  if (order.status === "error") {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        Ошибка при загрузке заказов. Попробуйте обновить страницу.
      </div>
    );
  }

  // Убедимся, что у нас есть массив items
  const items = order.items || [];
  // Фильтруем только завершенные заказы
  const completedItems = items.filter(item => item.state === true);

  return (
    <section>
      <ul className="completed-services__items">
        {completedItems.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              color: "#b2b2b2",
              padding: "32px 0",
            }}>
            У вас нет завершенных заказов
          </div>
        ) : (
          <>
            {[...completedItems].reverse().map(item => {
              const date = new Date(item.date);
              const day = date.getDate();
              const month = months[date.getMonth()];
              const hours = date.getHours();
              const minutes = date.getMinutes().toString().padStart(2, "0");

              return (
                <li
                  className="completed-services__item completed-services__item-block"
                  key={item._id}
                  style={{
                    padding: "18px 14px",
                  }}>
                  <div className="block-main">
                    <div className="text">
                      <div>{item.group}</div>
                    </div>
                    <div className="text">
                      <div>Заказ № {item.orderNumber}</div>
                    </div>
                    <div className="text block">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          width: "100%",
                        }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}>
                          <StarRating
                            orderId={item._id}
                            initialRating={item.review?.rating || 0}
                          />
                          {!activeReview?.orderId === item._id &&
                            !item.review && (
                              <button
                                onClick={() =>
                                  setActiveReview({
                                    orderId: item._id,
                                    rating: 0,
                                  })
                                }
                                className="completed-services__button"
                                style={{
                                  fontSize: "14px",
                                  padding: "4px 8px",
                                }}>
                                Оставить отзыв
                              </button>
                            )}
                        </div>

                        {reviewStatus === "loading" &&
                        activeReview?.orderId === item._id ? (
                          <div style={{ fontSize: "14px", color: "#666" }}>
                            Отправка отзыва...
                          </div>
                        ) : (
                          <>
                            {activeReview?.orderId === item._id ? (
                              <div style={{ width: "100%" }}>
                                <textarea
                                  value={comment}
                                  onChange={e => setComment(e.target.value)}
                                  placeholder="Оставьте свой комментарий"
                                  style={{
                                    width: "100%",
                                    padding: "8px",
                                    marginBottom: "8px",
                                    borderRadius: "4px",
                                    border: "1px solid #ddd",
                                  }}
                                />
                                <div style={{ display: "flex", gap: "8px" }}>
                                  <button
                                    onClick={handleSubmitReview}
                                    className="completed-services__button"
                                    style={{
                                      fontSize: "16px",
                                      padding: "4px 8px",
                                      border: "none",
                                      background: "none",
                                      color: "#4a90e2",
                                    }}>
                                    {item.review
                                      ? "Обновить отзыв"
                                      : "Отправить отзыв"}
                                  </button>
                                  <button
                                    onClick={() => {
                                      setActiveReview(null);
                                      setComment("");
                                    }}
                                    className="completed-services__button"
                                    style={{
                                      fontSize: "16px",
                                      padding: "4px 8px",
                                      border: "none",
                                      background: "none",
                                      color: "#4a90e2",
                                    }}>
                                    Отмена
                                  </button>
                                </div>
                              </div>
                            ) : (
                              item.review && (
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "#666",
                                    background: "#f9f9f9",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    position: "relative",
                                    width: "280px",
                                  }}>
                                  <div style={{ marginBottom: "8px" }}>
                                    <strong>Ваш отзыв:</strong>
                                    <p style={{ margin: "4px 0" }}>
                                      {item.review.comment}
                                    </p>
                                  </div>
                                  {item.review.adminResponse && (
                                    <div
                                      style={{
                                        borderTop: "1px solid #eee",
                                        paddingTop: "8px",
                                        marginTop: "8px",
                                      }}>
                                      <strong style={{ color: "#4a90e2" }}>
                                        Ответ администратора:
                                      </strong>
                                      <p
                                        style={{
                                          margin: "4px 0",
                                          color: "#4a90e2",
                                        }}>
                                        {item.review.adminResponse.text}
                                      </p>
                                      <small
                                        style={{
                                          color: "#999",
                                          fontSize: "12px",
                                        }}>
                                        {new Date(
                                          item.review.adminResponse.createdAt
                                        ).toLocaleString()}
                                      </small>
                                    </div>
                                  )}
                                  <button
                                    onClick={() => {
                                      setActiveReview({
                                        orderId: item._id,
                                        rating: item.review.rating,
                                      });
                                      setComment(item.review.comment);
                                    }}
                                    className="completed-services__button"
                                    style={{
                                      position: "absolute",
                                      top: "12px",
                                      right: "12px",
                                      fontSize: "12px",
                                      padding: "4px 8px",
                                      border: "none",
                                      background: "none",
                                      color: "#4a90e2",
                                    }}>
                                    Изменить
                                  </button>
                                </div>
                              )
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="">{`${day} ${month} ${hours}:${minutes}`}</div>
                  </div>

                  <div className="block-main top block-main__right">
                    <div className="completed-services__button">
                      Чек об оплате
                    </div>
                    <div className="price">{item.price} ₽</div>
                  </div>
                </li>
              );
            })}
          </>
        )}
      </ul>
    </section>
  );
});

export default CompletedServices;
